// import { get as getUser } from '../utils/token'
import SetNickName from '../components/setNickName.vue'
export default {
  components: {
    SetNickName
  },
  data () {
    return {
      showSetNickName: false
    }
  },
  methods: {
    judgeUserNickName () {
      // nickName为空会跳转修改头像和昵称   弃用
      // const user = getUser('user')
      // if (user && (!user.nickName || !user.avatar || (user.avatar === 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/g.jpeg'))) {
      //   this.showSetNickName = true
      //   return true
      // }
      return false
    }
  }
}
